import React from 'react';
import { Box, Typography } from '@mui/material';
import { ImgBox } from 'views/rebranded-module/common/components';
import useAdabtiveMultiSizeImage from 'views/common/hooks/useAdabtiveMultiSizeImage';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import StyledBox from 'views/rebranded-module/information-module/AboutUsViewV2/components/ExperienceSection/ExperienceSection.styles';

const ExperienceSection: React.FC = () => {
  const content = useContent('AboutUsPage');
  const getSizedImage = useAdabtiveMultiSizeImage();
  return (
    <StyledBox>
      <Box className="ESOverlay" />
      <Box className="ESBackgroundImage">
        <ImgBox
          image={{
            src: getSizedImage(content.experienceBackgroundImage),
            alt: content.experienceBackgroundImage.alt,
          }}
          width="100%"
          height="100%"
          unoptimized
        />
      </Box>
      <Box className="ESContent">
        <Typography
          variant="h3"
          component="h3"
          className="ESHeading"
          textTransform="uppercase"
          dangerouslySetInnerHTML={{ __html: content.experienceHeading }}
        />
        <Typography
          variant="body2"
          component="p"
          className="ESParagraph"
          dangerouslySetInnerHTML={{ __html: content.experienceParagraph }}
        />
      </Box>
    </StyledBox>
  );
};

export { ExperienceSection };
